import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { SpinnerGap, Warning } from '@phosphor-icons/react';
import { exchangeMagicToken, setCustomerToken } from '../services/customerApi';

const CustomerAuthPage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('exchanging'); // exchanging | error
    const [errorMsg, setErrorMsg] = useState('');

    useEffect(() => {
        const token = searchParams.get('token');
        if (!token) {
            setStatus('error');
            setErrorMsg('Enlace inválido — falta el token');
            return;
        }
        (async () => {
            try {
                const res = await exchangeMagicToken(token);
                setCustomerToken(res.data.token);
                navigate('/me', { replace: true });
            } catch (err) {
                setStatus('error');
                setErrorMsg(err.response?.data?.detail || 'Enlace inválido o expirado');
            }
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="min-h-screen bg-[#F4ECE0] flex items-center justify-center px-4">
            {status === 'exchanging' && (
                <div className="text-center" data-testid="customer-auth-loading">
                    <SpinnerGap size={32} className="animate-spin text-[#1F2D4B] mx-auto mb-3" />
                    <p className="text-sm text-[#4B5878]">Validando tu acceso…</p>
                </div>
            )}
            {status === 'error' && (
                <div className="max-w-md bg-white border border-[#ECE3D2] rounded-2xl p-8 text-center" data-testid="customer-auth-error">
                    <Warning size={32} weight="duotone" className="text-[#C8413A] mx-auto mb-3" />
                    <h2 className="font-display text-xl font-semibold text-[#1F2D4B] mb-2">No pudimos validarte</h2>
                    <p className="text-sm text-[#4B5878] mb-5">{errorMsg}</p>
                    <Link
                        to="/me/login"
                        className="inline-block h-11 px-6 bg-[#1F2D4B] hover:bg-[#2E3F60] text-white rounded-md font-medium leading-[44px]"
                    >
                        Solicitar otro enlace
                    </Link>
                </div>
            )}
        </div>
    );
};

export default CustomerAuthPage;
